var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramwhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 13C1 7.34358 1 4.51411 2.75705 2.75705C4.51411 1 7.34232 1 13 1C18.6564 1 21.4859 1 23.2429 2.75705C25 4.51411 25 7.34232 25 13C25 18.6564 25 21.4859 23.2429 23.2429C21.4859 25 18.6577 25 13 25C7.34358 25 4.51411 25 2.75705 23.2429C1 21.4859 1 18.6577 1 13Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9574 6.05273H19.9447M18.6841 13.0001C18.6841 14.5076 18.0852 15.9535 17.0192 17.0194C15.9532 18.0854 14.5074 18.6843 12.9999 18.6843C11.4923 18.6843 10.0465 18.0854 8.98054 17.0194C7.91454 15.9535 7.31567 14.5076 7.31567 13.0001C7.31567 11.4926 7.91454 10.0468 8.98054 8.98076C10.0465 7.91476 11.4923 7.31589 12.9999 7.31589C14.5074 7.31589 15.9532 7.91476 17.0192 8.98076C18.0852 10.0468 18.6841 11.4926 18.6841 13.0001Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramwhite);
export default __webpack_public_path__ + "static/media/instagramwhite.039c9e5f8cb5358317a845bd8fffe12d.svg";
export { ForwardRef as ReactComponent };